import {createElement, Component, PropTypes} from 'rlink-react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import Main from 'components/main';
import css from 'static/style/dow.less';
import contentLoader from 'helpers/content-loader';
import popModal from 'rlink-router/actions/popModal';
import {DISCLAIMER} from 'rlink-shop/messages';

const CloseButton = connect(null,
  {
    onClose: popModal,
  }
)(class CloseButton extends Component {
  render () {
    return <div className={css['close-button']} onClick={() => this.props.onClose()}>×</div>;
  }
});

export default function (params, content) {
  return (<Main bare={params.bare} globalSettings={content.globalSettings}>
    <div key="disclaimer" className={css['disclaimer-modal']}>
      <CloseButton />
      <div className={css['modal-content']}>
        <div className={css.heading}>
          <FormattedMessage
            id="ui.label.title.DISCLAIMER_POWERED_BY"
            defaultMessage="Store Powered By:"
            description="Heading that appears on the store disclaimer page." />
        </div>
        <img className={`${css['vendor-logo']} ${css['no-icon']}`} src={contentLoader('humble-bundle-no-logo.png')} />
        <div className={css['legal-heading']}>
          <FormattedMessage
            id="ui.label.title.HUMBLE_BUNDLE_DISCLAIMER_LEGAL"
            defaultMessage="Terms and Conditions"
            description="Heading that appears on the store disclaimer page." />
        </div>
        <p className={css['legal-content']}>
          {DISCLAIMER}
        </p>
        <img className={css['vendor-logo']} src={contentLoader('humble-bundle-logo-only.png')} />
        <a rel="noopener noreferrer" target="_blank" href="https://www.humblebundle.com/terms">
          <button className={`${css['more-info']} ${css.btn} ${css['btn-small']} ${css['button-foreground']}`}>
            <FormattedMessage
              id="ui.label.link.TERMS_FIND_OUT_MORE"
              defaultMessage="find out more"
              description="Link to full legal terms page appearing on store disclaimer page." />
          </button>
        </a>
      </div>
    </div>
  </Main>);
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/humble-bundle-disclaimer.jsx